import { create } from 'zustand'
import apiCore from '../utils/api-core'

const useQueuesStore = create((set, get) => ({
  queues: [],
  jobs: [],
  stats: [],
  selectedQueue: null,
  selectedStatus: 'completed',
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  jobsLoading: false,

  fetchStats: async () => {
    try {
      const result = await apiCore.get('/api/v3/queues/stats')
      set({ stats: result?.data?.stats || [] })
    } catch (error) {
      console.error('[queues] fetchStats error:', error)
    }
  },

  fetchQueues: async () => {
    try {
      const result = await apiCore.get('/api/v3/queues')
      set({ queues: result?.data?.queues || [] })
    } catch (error) {
      console.error('[queues] fetchQueues error:', error)
    }
  },

  fetchJobs: async (name, status, page = 1) => {
    set({ jobsLoading: true })
    try {
      const result = await apiCore.get(`/api/v3/queues/${name}/jobs`, {
        params: { status, page },
      })
      const data = result?.data || {}
      set({
        jobs: data.jobs || [],
        pagination: data.pagination || { page: 1, pageSize: 20, total: 0, totalPages: 0 },
        selectedQueue: name,
        selectedStatus: status,
      })
    } catch (error) {
      console.error('[queues] fetchJobs error:', error)
    } finally {
      set({ jobsLoading: false })
    }
  },

  getJob: async (name, jobId) => {
    const result = await apiCore.get(`/api/v3/queues/${name}/jobs/${jobId}`)
    return result?.data?.job
  },

  retryJob: async (name, jobId) => {
    await apiCore.post(`/api/v3/queues/${name}/jobs/${jobId}/retry`)
    // Refresh the jobs list
    const { selectedStatus, pagination } = get()
    await get().fetchJobs(name, selectedStatus, pagination.page)
    await get().fetchQueues()
  },

  retryAllFailed: async (name) => {
    const result = await apiCore.post(`/api/v3/queues/${name}/retry-all`)
    // Refresh
    const { selectedStatus, pagination } = get()
    await get().fetchJobs(name, selectedStatus, pagination.page)
    await get().fetchQueues()
    return result?.data?.retriedCount
  },
}))

export default useQueuesStore
